import React from "react";
import { Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";

export default function FavoriteButton({ bookId, bookTitle, variant = "icon" }) {
  const fav = useFavorites();
  if (!fav) return null;
  const active = fav.isFavorite(bookId);

  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    fav.toggle(bookId, bookTitle);
  };

  if (variant === "button") {
    return (
      <button
        data-testid={`favorite-btn-${bookId}`}
        onClick={handle}
        className={`inline-flex items-center gap-2 px-4 py-3 border transition-colors text-xs uppercase tracking-widest ${
          active
            ? "bg-terracotta text-paper border-terracotta"
            : "border-ink text-ink hover:bg-ink hover:text-paper"
        }`}
      >
        <Heart className={`w-4 h-4 ${active ? "fill-paper" : ""}`} strokeWidth={1.5} />
        {active ? "Saved" : "Save"}
      </button>
    );
  }

  return (
    <button
      data-testid={`favorite-icon-${bookId}`}
      onClick={handle}
      className="p-1.5 bg-paper/95 backdrop-blur-sm border border-edge hover:bg-terracotta hover:text-paper hover:border-terracotta transition-colors"
      title={active ? "Remove from favorites" : "Save to favorites"}
    >
      <Heart
        className={`w-4 h-4 ${active ? "fill-terracotta text-terracotta hover:fill-paper hover:text-paper" : "text-ink"}`}
        strokeWidth={1.5}
      />
    </button>
  );
}
